import { render, staticRenderFns } from "./no_approve.vue?vue&type=template&id=482fde87&scoped=true"
import script from "./no_approve.vue?vue&type=script&lang=js"
export * from "./no_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fde87",
  null
  
)

export default component.exports